import {svgIconWrapper} from '../svg-icon-wrapper';

import ChatEllipsisSolid from './chat-ellipsis-solid-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ChatEllipsisSolid {...validProps} />;
}
SvgComponent.iconName = 'chatEllipsisSolid';

export const ChatEllipsisSolidIcon = svgIconWrapper(SvgComponent);
